module.exports = __webpack_public_path__ + "img/1508975961.9ebe2d94.jpg";